class CapacityGroup {
    constructor(json) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.urgentCapacityPercentage = json.urgentCapacityPercentage || 0;
        } else {
            this.id = null;
            this.name = '';
            this.urgentCapacityPercentage = 0;
        }
    }
}

export default CapacityGroup;
